/**
 * GW-13932: The native browser EventSource cannot send request headers, so SSE
 * requests to the Cognito-authorized SDK gateway arrive without Authorization
 * and are rejected with 401. event-source-polyfill accepts an init object with
 * `headers` and is otherwise a superset of the native API.
 *
 * Installs the polyfill as the global EventSource. Idempotent; browser only.
 */

import { EventSourcePolyfill } from 'event-source-polyfill';

export function installEventSourcePolyfill(): void {
  if (typeof window === 'undefined') return;
  if (globalThis.EventSource === (EventSourcePolyfill as unknown)) return;
  globalThis.EventSource = EventSourcePolyfill as unknown as typeof EventSource;
}
